
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/products/identity-verification",
      function () {
        return require("private-next-pages/docs/api/products/identity-verification.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/products/identity-verification"])
      });
    }
  